module.exports = __webpack_public_path__ + "img/pro2.48e5a6ce.png";